'use strict';

const sign = (data) => {
    const { type, status, participant, outcome } = data;
    if (
        ['planned', 'waitlist', 'onhold'].indexOf(status) >= 0 &&
        type === 'phone' &&
        participant === 'patient' &&
        outcome === 'enrolled'
    ) {
        return {
            status: 'active',
            warning:
                "Patient's status will be set to active when this encounter is signed. If you do not wish for this to occur, change the outcome to something other than Enrolled."
        };
    }
    return null;
};

module.exports = {
    sign
};
